import React from 'react';
import JotformEmbed from 'react-jotform-embed';
import Page from '../components/page/Page';
import PageHeader from '../components/pageHeader/PageHeader';
import team from '../images/DSC_4455.jpeg';
import holdingHands from '../images/holding_hands_icon.png';
import data from '../site-data.json';
import styles from './careers.module.scss';

const Careers = (): JSX.Element => (
  <Page title={`${data.siteName} - Careers`}>
    <PageHeader title="Careers" image={team} />
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <p>
          Having lived and breathed the childcare industry for over 30 years,
          Erin knows how it can be such a rewarding career. She also understands
          and acknowledges its challenges for educators.
        </p>
        <p>
          This is why our teams are offered additional benefits you won&apos;t
          see anywhere else.
        </p>
        <p>What We Offer</p>
        <ul>
          <li>Above Award Wages</li>
          <li>Up to 95% Childcare Staff Discount</li>
          <li>Two Extra Wellbeing Days (Rest and Recharge)</li>
          <li>Weekly Incentives: Earn an extra $1 an hour for teamwork</li>
          <li>Refer a Friend Incentive: Earn between $500-$1500!</li>
          <li>
            Travel Assistance: Commuting from Canberra? Ask us about car or
            travel expense support!
          </li>
        </ul>
        <p>Why Choose Us?</p>
        <ul>
          <li>
            Experienced Leadership: Our approved provider brings over 30 years
            of expertise in the childcare industry, committed to supporting your
            professional growth
          </li>
          <li>
            Supportive Environment: Join a dedicated team of educators who are
            passionate about making a difference in children&apos;s lives
          </li>
          <li>
            Professional Development: We invest in our team with monthly budgets
            for ongoing training and development opportunities to enhance your
            skills
          </li>
          <li>
            Generous Resource Budgets: Focus on creating enriching experiences
            for children without financial constraints
          </li>
          <li>
            Community Engagement: Build strong relationships with families and
            contribute to a welcoming and inclusive environment
          </li>
        </ul>
        <p>
          If you&apos;re passionate about a career in early childhood, please
          complete the form below.
        </p>
        <div className={styles.textImageWrapper}>
          <div className={styles.textWrapper}>
            <p>Be sure to include these with your CV:</p>
            <ol>
              <li>
                Shine a light on all the things that make you a great employee
              </li>
              <li>
                Share your level of experience working with children and
                families
              </li>
              <li>
                Let us know why you think you&apos;ll be a good fit for the team
              </li>
              <li>Personal and 2 x professional referees who we can contact</li>
            </ol>
          </div>
          <div className={styles.imageWrapper}>
            <img src={holdingHands} alt="Holding Hands" />
          </div>
        </div>
        <JotformEmbed src="https://form.jotformeu.com/250091125969056" />
      </div>
    </div>
  </Page>
);

export default Careers;
